module.exports = __webpack_public_path__ + "img/cashReceive.2945a8f8.svg";